import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';

import { connect } from 'react-redux';
import { startEditing } from 'bundles/apex/deals/show/store/overview/actions';

import { Button } from 'components/ui/button';
import { getInvalidFieldsByTab } from 'bundles/apex/deals/show/config';

export function OverviewHeader({ fields, invalidFields, startEditing }) {
  return (
    <div className="apex-card full-width d-flex gap-2 align-items-center justify-content-between flex-grow-1 pt-2">
      <h5 className="flex-grow-1">Overview</h5>
      <div className="d-flex align-items-center gap-1">
        {getInvalidFieldsByTab(fields, invalidFields).overview.length > 0 &&
          <FontAwesomeIcon className="me-3 text-destructive" icon={faExclamationCircle} size="xl" />
        }

        <Button icon={faEdit} label="Edit" variant="outline" onClick={startEditing} />
      </div>
    </div>
  );
}

OverviewHeader.propTypes = {
  fields: PropTypes.object,
  invalidFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  startEditing: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  fields: state.fields,
  invalidFields: state.invalidFields,
});

const mapDispatchToProps = {
  startEditing,
};

export default connect(mapStateToProps, mapDispatchToProps)(OverviewHeader);
